import React, { Component } from 'react'
import { connect } from 'react-redux'
import Paginator from '../paginator'
import css from './style.css'
import * as actions from '../../actions/search'

export const mapStateToProps = (state, ownProps) => {
  return {
    pagination: state.diamondSearch.pagination || {total_hits: 0, current_page: 0, hits_per_page: 0}
  }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onPagerClicked: (val) => {
      dispatch(actions.setPageAndsearch(val))
    }
  }
}

export class PaginationFooter extends Component {
  render () {
    const props = this.props
    return (
      <div className={css.centered}>
        <Paginator
          pageNum={Math.ceil(props.pagination['total_hits'] / props.pagination['hits_per_page']) || 1}
          onClick={props.onPagerClicked}
          forceSelected={props.pagination['current_page']}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginationFooter)



// WEBPACK FOOTER //
// ./src/components/search-results/pagination-footer.js